module.exports = __webpack_public_path__ + "img/feedback-given.e8d348db.svg";